import { LocalStorage } from 'src/utils'

export const STORAGE_KEY = 'km_recorder_tooltips'

export const isFirstTimeRecord = () => {
  return !LocalStorage.getItem<boolean>(STORAGE_KEY)
}
